var webooker_franchise_models = webooker_franchise_models || {};

(function (ns) {

    ns.FranchiseEmployee = function (employeeDTO) {
        this.employeeDTO = employeeDTO;

        this.fullName = employeeDTO.fullName;
    }

    Object.defineProperty(ns.FranchiseEmployee.prototype, 'franchiseActive', {
        enumerable: true, configurable: true,
        get: function () {
            return this.employeeDTO.franchises[0].active;
        },
        set: function (value) {
            this.employeeDTO.franchises[0].active = value;
        }
    });

    Object.defineProperty(ns.FranchiseEmployee.prototype, 'licenses', {
        enumerable: true, configurable: true,
        get: function () {
            return this.employeeDTO.franchises[0].licenses;
        },
        set: function (value) {
            this.employeeDTO.franchises[0].licenses = value;
        }
    });

})(webooker_franchise_models);